import { oc } from '@orpc/contract'
import { z } from 'zod'

export const taskColumnSchema = z.object({
  columnId: z.string().min(1),
  displayName: z.string().min(1),
})

export const taskColumnsListContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
    })
  )
  .output(
    z.object({
      items: z.array(taskColumnSchema),
    })
  )

export const taskColumnsUpdateContract = oc
  .input(
    z.object({
      projectId: z.string().min(1),
      columnId: z.string().min(1),
      displayName: z.string().min(1),
    })
  )
  .output(z.object({ ok: z.literal(true) }))
